import find from 'lang-codes';

export default function findLangaugeNameFromKey(value = '') {
  const lang = find(value, { prop: 'name' });
  return lang.name || `N/A (${value})`;
}



// WEBPACK FOOTER //
// ./src/helpers/lang.js